import axios from 'axios';

export const GET_HOME_PAGE = 'GET_HOME_PAGE';
export const GET_ALL_PAGE_CONTENTS = 'GET_ALL_PAGE_CONTENTS';

// Get the home page.
export const getHomePage = () => {
  return function(dispatch) {
    return axios.get('https://private-f5bbc-rafaelnogueira.apiary-mock.com/api/front')
      .then(response => {
        dispatch({ type: GET_HOME_PAGE, homePagePayload: response.data });
      })
      .catch(error => {
        console.log(error);
      });
  };
};

// Page contents.
export const getAllPageContents = () => {
  return function(dispatch) {
    return axios.get('http://nogueira-api.local/jsonapi/node/page')
      .then(response => {
        dispatch({ type: GET_ALL_PAGE_CONTENTS, allPageContentsPayload: response.data });
      })
      .catch(error => {
        console.log(error);
      });
  };
};
